import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import imgLocation from "../../assets/images/permission/location.svg";
import imgPhoto from "../../assets/images/permission/photo.svg";
import imgNotification from "../../assets/images/permission/notification.svg";
import imgBattery from "../../assets/images/permission/battery.svg";
import imgAllow from "../../assets/images/permission/allow.png";
import imgDontAllow from "../../assets/images/permission/dont_allow.png";

const USER_PERMISSIONS: any = [
  {
    id: 1,
    title: "Location",
    key: "location",
    icon: imgLocation,
  },
  {
    id: 2,
    title: "Photo",
    key: "photo",
    icon: imgPhoto,
  },
  {
    id: 3,
    title: "Notification",
    key: "notification",
    icon: imgNotification,
  },
  // {
  //   id: 4,
  //   title: "Battery Optimization",
  //   key: "battery_optimize",
  //   icon: imgBattery,
  // },
];

const ROLE_PERMISSION: any = {
  0: "Don't Allow",
  1: "Allow",
  2: "Allow while using in app",
  3: "Allow limit access",
};

const PermissionItem = ({ icon, title, value=0, permissionKey, handleShowNotification, userID }: any) => {
  const { t, i18n } = useTranslation();
  const widthPermission = i18n?.language === "ko" ? "110px" : "170px";

  const getPermissionStatus = (status: any) => {
    const imgSrc = status === 0 ? imgDontAllow : imgAllow;
    return (
      <div className="cursor-pointer d-flex gap-1 align-items-center whitespace-nowrap">
        <img width={12} height={12} src={imgSrc} alt={t(ROLE_PERMISSION?.[status])} />
        <div>{t(ROLE_PERMISSION?.[status])}</div>
      </div>
    );
  };

  return (
    <div className="d-flex gap-2">
      <div className="d-flex gap-2" style={{width: widthPermission}}>
        <div style={{ width: "16px" }}>
          {icon && <img src={icon} alt={t(title)} />}
        </div>
        <div>{t(title)}</div>
      </div>
      
      <div>
        {getPermissionStatus(value)}
      </div>
      {/* {
          (permissionKey === 'notification' && value === 1) && (
            <div>
              <small 
                className="text-primary text-decoration-underline cursor-pointer position-relative" 
                onClick={() => {
                  handleShowNotification && handleShowNotification(userID);
                }}
                >
                {t('View Detail')}
              </small>
            </div>
          )
        } */}
    </div>
  );
};

const Permission = ({ permission, userID, handleShowNotification }: any) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="w-100">
        <Row>
          {USER_PERMISSIONS.map(({ id, title, key, icon }: any) => (
            <div key={id} className="d-flex gap-2">
              <PermissionItem
                icon={icon}
                title={title}
                value={permission?.[key]}
                permissionKey={key}
                handleShowNotification={handleShowNotification}
                userID={userID}
              />
            </div>
          ))}
        </Row>
      </div>
    </>
  );
};

export default Permission;
